import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// Vuex.Store 构造器选项
const store = new Vuex.Store({
    state: {
        // 用户信息
        userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
        // 系统设置
        setting: localStorage.getItem('setting') ? JSON.parse(localStorage.getItem('setting')) : {},
        // 登录token
        token: localStorage.getItem('ToKen') || '',
        // token过期标识
        tokenInvalidFlag: false,
    },
    mutations: {
        // 用户信息
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo;
            // 将用户信息存入localStorage
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
        },
        // token
        setToken(state, token) {
            state.token = token;
            // 将token存入localStorage
            localStorage.setItem('ToKen', token);
        },
        // 系统设置
        setSetting(state, setting) {
            state.setting = setting;
            // 将系统设置存入localStorage
            localStorage.setItem('setting', JSON.stringify(setting));
        },
        // 退出登录
        logout(state) {
            state.token = '';
            state.userInfo = {};
            state.setting = {};
            // 将用户信息从localStorage中移除
            localStorage.removeItem('userInfo');
            // 将token从localStorage中移除
            localStorage.removeItem('ToKen');
            // 将setting从localStorage中移除
            localStorage.removeItem('setting');
        },
    },
    actions: {

    },
});

export default store;
